module.exports = __webpack_public_path__ + "media/pres_CNP.3f45953d.mp4";